module.exports = "<div class=\"item item-input {{className}}\">\r\n    <div class=\"input-label\" id=\"_label-1\">\r\n        <span class=\"input-caption ng-binding\">{{label}}</span>\r\n    </div>\r\n\r\n    <div class=\"input-content\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/input-field/input-field.component.html
// module id = ./src/app/commons/input-field/input-field.component.html
// module chunks = main